/**
 * Mehrere Nachlade-Signale kurz hintereinander = EIN Nachladen (T-49).
 *
 * Jedes Socket-Signal `onVorgangDirty` lud die ganze Vorgangsseite neu —
 * Vorgang, Notizen, Mails, Anrufe, Dokumente, Termine. Eine Übernahme, ein
 * Verschieben oder mehrere Kolleginnen am selben Vorgang schicken davon
 * gern eine Salve, und jede lief vollständig durch. Hier wird gebündelt:
 *
 * - Signale innerhalb von `wartezeitMs` werden zu einem Lauf.
 * - Läuft gerade ein Lauf, wird höchstens EIN Folgelauf vorgemerkt — er
 *   startet, sobald der laufende fertig ist, und sieht damit den Stand nach
 *   allen Signalen.
 */
export function nachladenBuendeln(
    laden: () => Promise<unknown>,
    wartezeitMs = 300,
): { anstossen: () => void; abbrechen: () => void } {
    let timer: ReturnType<typeof setTimeout> | null = null;
    let laeuft = false;
    let nochmal = false;
    let aus = false;

    const starte = async (): Promise<void> => {
        if (aus) return;
        if (laeuft) {
            nochmal = true;
            return;
        }
        laeuft = true;
        try {
            await laden();
        } catch {
            // Der Aufrufer meldet seine Fehler selbst; ein gescheiterter Lauf
            // darf den nächsten nicht blockieren.
        } finally {
            laeuft = false;
        }
        if (nochmal && !aus) {
            nochmal = false;
            void starte();
        }
    };

    return {
        anstossen() {
            if (aus) return;
            if (timer != null) clearTimeout(timer);
            timer = setTimeout(() => {
                timer = null;
                void starte();
            }, wartezeitMs);
        },
        abbrechen() {
            aus = true;
            if (timer != null) clearTimeout(timer);
            timer = null;
        },
    };
}
